export default {
  // Ticket List page
  "Tickets List": "Tickets List",
  "New Ticket": "New Ticket",
  "Loading tickets...": "Loading tickets...",
  "No tickets found matching your search":
    "No tickets found matching your search",
  "No tickets found": "No tickets found",
  "Tickets will appear here after they are created.":
    "Tickets will appear here after they are created.",
  "Something went wrong": "Something went wrong",
  "We're having technical difficulties retrieving your tickets. Please try again.":
    "We're having technical difficulties retrieving your tickets. Please try again.",
  "Try Again": "Try Again",
  Ticket: "Ticket",
  Approval: "Approval",
  "Knowledge base": "Knowledge base",
  // Ticket Status
  WAITING_FOR_SUPPORT: "Waiting for support",
  IN_PROGRESS: "In progress",
  ON_HOLD: "On hold",
  PENDING_INFORMATION: "Pending information",
  WAITING_FOR_EMPLOYEE: "Waiting for employee",
  Resolved: "Resolved",
  Cancelled: "Cancelled",
  "Additional information for the IT admin":
    "Additional information for the IT admin",
  // New Ticket Form
  "Create New Support Ticket": "Create New Support Ticket",
  "Fill out the form below to create a new support ticket":
    "Fill out the form below to create a new support ticket",
  "Request Type": "Request Type",
  "Select request type": "Select request type",
  "Select Asset": "Select Asset",
  "Select your asset": "Select your asset",
  "Asset Type": "Asset Type",
  "Select asset type": "Select asset type",
  "Request Date": "Request Date",
  "Select request date": "Select request date",
  "Assign To": "Assign To",
  "Select assignee": "Select assignee",
  Priority: "Priority",
  "Select priority": "Select priority",
  Summary: "Summary",
  "Enter a brief summary of your issue": "Enter a brief summary of your issue",
  Description: "Description",
  "Provide detailed information about your issue":
    "Provide detailed information about your issue",
  Attachments: "Attachments",
  "Allowed file types": "Allowed file types",
  Max: "Max",
  Cancel: "Cancel",
  "Submit Ticket": "Submit Ticket",
  "Submitting...": "Submitting...",
  "Drag and drop files here or click to browse":
    "Drag and drop files here or click to browse",
  files: "files",
  total: "total",
  "Browse Files": "Browse Files",
  "Uploaded Files": "Uploaded Files",

  // File Upload
  "Invalid file format": "Invalid file format",
  "File limit exceeded": "File limit exceeded",
  "Size limit exceeded": "Size limit exceeded",
  "You can upload a maximum of {{count}} files":
    "You can upload a maximum of {{count}} files",
  "Total attachment size cannot exceed {{size}}MB":
    "Total attachment size cannot exceed {{size}}MB",
  Only: "Only",
  "files accepted": "files accepted",

  // Toast messages
  "Ticket created": "Ticket created",
  HARDWARE_ISSUES: "Hardware",
  OTHER: "Other",
  ACCOUNT_AND_ACCESS: "Account & Access",
  APPLICATION_ISSUES: "Application",
  PENDING_SUPPORT: "Pending support",
  POLICY_AND_SECURITY: "Policy & Security",
  SOFTWARE_AND_OS: "Software & OS",

  "Your ticket has been successfully created":
    "Your ticket has been successfully created",
  Error: "Error",
  "Failed to create ticket. Please try again.":
    "Failed to create ticket. Please try again.",
  Success: "Success",

  // Request Types
  "Hardware Issues": "Hardware Issues",
  "Asset Request": "Asset Request",
  "Account & Access": "Account & Access",
  "Application Issues": "Application Issues",
  "Software & Operating System": "Software & Operating System",
  "Policy & Security": "Policy & Security",
  Other: "Other",

  // Asset Types
  Device: "Device",
  Accessories: "Accessories",
  PDF: "PDF",
  Furniture: "Furniture",

  // Priorities
  Low: "Low",
  Medium: "Medium",
  High: "High",
  Critical: "Critical",

  // User
  User: "User",

  // Validation Messages
  "Request type is required": "Request type is required",
  "Summary is required": "Summary is required",
  "Description is required": "Description is required",
  "Asset selection is required": "Asset selection is required",
  "Asset type is required": "Asset type is required",
  "Request date is required": "Request date is required",
};
